// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/Users/gaofuhong/X6-v2/sites/x6-sites/node_modules/@antv/dumi-theme-antv/dist/slots/Loading/index.js';
